import React, { Component } from 'react';
import { List, Button, message } from "antd";

import Events from "../../services/events";

import PageHeader from "../../components/Modules/PageHeader";
import FilterPanel from "../../components/Modules/FilterPanel";
import AskForLogin from '../../components/Modules/AskForLogin';
import ListItem from '../../components/ListItem';

import { database } from '../../services/firebase/firebase';

import './Search.less';

const convertedType = {
  user: {
    collection: 'users',
    button: 'Profile',
    titleSearch: 'User search',
    redirectPage: 'profile'
  },
  channel: {
    collection: 'channels_cache',
    button: 'Channel',
    titleSearch: 'Channel search',
    redirectPage: 'Channels'
  },
  event: {
    collection: 'events',
    button: 'Event',
    titleSearch: 'Event search',
    redirectPage: 'watch'
  },
  all: {
    collection: ['users', 'channels_cache', 'events'],
    button: ['Profile','Channel', 'Event'],
    titleSearch: 'Search all',
    redirectPage: ['profile', 'Channels', 'watch']
  },
};

export default class Search extends Component {

  state = {
    searchValue: '',
    type: '',
    reverseRedirection: null,
    result: '',
    error: '',
    width: 0,
    height: 0,
    visibleRegistration: false,
    visibleAuth: true,
    activeType: 'auth'
  }

  async componentDidMount() {
    const searchQuery = this.props.location.search;
    const urlParams = new URLSearchParams(searchQuery);
    const value = urlParams.get('value') ? urlParams.get('value').toLowerCase() : "";
    const type = urlParams.get('type') ? urlParams.get('type') : "all";
    const reverseRedirection = urlParams.get('redirect')
      ? urlParams.get('redirect')
      : null;

    if (reverseRedirection) {
      this.setState({ reverseRedirection: reverseRedirection });
    }

    const { data } = this.props;

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    if (!convertedType[type]) {
      return message.error('Wrong Type!');
    }

    if (type === 'user') {
      return this.searching(type, value);
    }

    if (type === 'channel' && data && data.channels.length !== 0) {
      return this.searching(type, value);
    }

    if (type === 'event' && data && data.events.length !== 0) {
      return this.searching(type, value);
    }

    if (type === 'all' && data && data.events.length !== 0 && data.channels.length !== 0) {
      return this.searching(type, value);
    }
  };

  async componentDidUpdate(prevProps) {
    const searchQuery = this.props.location.search;
    const urlParams = new URLSearchParams(searchQuery);
    const value = urlParams.get('value') ? urlParams.get('value').toLowerCase() : "";
    const type = urlParams.get('type') ? urlParams.get('type') : "all";

    const { data } = this.props;
    const { searchValue } = this.state;

    if (!convertedType[type]) {
      return message.error('Wrong Type!');
    }

    if (type === 'user' && (searchValue !== value)) {
      return this.searching(type, value);
    }

    if (type === 'channel' && data && data.channels.length !== 0 && (searchValue !== value)) {
      return this.searching(type, value);
    }

    if (type === 'event' && data && data.events.length !== 0 && (searchValue !== value)) {
      return this.searching(type, value);
    }

    if (type === 'all' && data && data.events.length !== 0 && data.channels.length !== 0 && (searchValue !== value)) {
      return this.searching(type, value);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  async searching(type, value) {
    if (type === 'user') {
      try {
        let result = await database.ref(`${convertedType[type].collection}/`).once('value');
        result = result.val();
        if (result) {
          const keys = Object.keys(result);
          const users = keys.map(key => {
            return {
              ...result[key],
              title: result[key].DisplayName,
              id: key,
              type: type
            }
          });
          const matchingUsers = users.filter(user => {
            const DisplayName = user.DisplayName ? user.DisplayName.toLowerCase() : '';
            return DisplayName.indexOf(value) !== -1;
          }).sort(this.sorting);

          this.setState({ searchValue: value, type: type, result: matchingUsers });
        }
      } catch (err) {
        console.error(err);
        this.setState({ error: err});
        return Promise.reject(err)
      }
    }

    if (type === 'channel') {
      const matchingChannels = this.props.channels.filter(channel => {
        const ChannelTitle = channel.title ? channel.title.toLowerCase() : '';
        return ChannelTitle.indexOf(value) !== -1;
      }).map(channel => {
        return {
          ...channel,
          type: type,
          buttonTitle: 'Channel'
        }
      }).sort(this.sorting);

      this.setState({ searchValue: value, type: type, result: matchingChannels });
    }

    if (type === 'event') {
      const matchingEvents = this.props.events.filter(event => {
        const EventlTitle = event.title ? event.title.toLowerCase() : '';
        return EventlTitle.indexOf(value) !== -1;
      }).map(event => {
        return {
          ...event,
          type: type,
          buttonTitle: 'Event'
        }
      }).sort(this.sorting);

      this.setState({ searchValue: value, type: type, result: matchingEvents });
    }

    if (type === 'all') {
      let matchingUsers = [];

      const matchingEvents = this.props.events.filter(event => {
        const EventlTitle = event.title ? event.title.toLowerCase() : '';
        return EventlTitle.indexOf(value) !== -1;
      }).map(event => {
        return {
          ...event,
          type: 'event',
          buttonTitle: 'Event'
        }
      });

      const matchingChannels = this.props.channels.filter(channel => {
        const ChannelTitle = channel.title ? channel.title.toLowerCase() : '';
        return ChannelTitle.indexOf(value) !== -1;
      }).map(channel => {
        return {
          ...channel,
          type: 'channel',
          buttonTitle: 'Channel'
        }
      });

      try {
        let result = await database.ref(`${convertedType[type].collection[0]}/`).once('value');
        result = result.val();
        if (result) {
          const keys = Object.keys(result);
          const users = keys.map(key => {
            return {
              ...result[key],
              title: result[key].DisplayName,
              id: key,
              type: 'user'
            }
          });
          matchingUsers = users.filter(user => {
            const DisplayName = user.title ? user.title.toLowerCase() : '';
            return DisplayName.indexOf(value) !== -1;
          });
        }
      } catch (err) {
        console.error(err);
        this.setState({ error: err});
        return Promise.reject(err)
      }

      const result = [...matchingEvents, ...matchingChannels, ...matchingUsers].sort(this.sorting);

      this.setState({ searchValue: value, type: type, result: result });
    }
  };

  sorting(first, second) {
    const firstOption = first.title.toLowerCase();
    const secondOption = second.title.toLowerCase();

    if (firstOption > secondOption) {
      return 1;
    } else {
      return -1;
    }
  };

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  };

  setStateHandler = (obj) => {
    this.setState(obj)
  };

  render() {
    const { reverseRedirection } = this.state;

    const searchQuery = this.props.location.search;
    const urlParams = new URLSearchParams(searchQuery);
    const type = urlParams.get('type');

    let content = (
      <div className="page-content-inner page-list">
        <List
          className="list-items"
          itemLayout="horizontal"
          dataSource={this.state.result || []}
          split={false}
          renderItem={item => {
            const { width } = this.state;

            const redirectLink = reverseRedirection ?
              `/${convertedType[item.type].redirectPage}/${item.id}?redirect=${reverseRedirection}`
              : `/${convertedType[item.type].redirectPage}/${item.id}`;

            return <ListItem
              item={item}
              width={width}
              redirectLink={redirectLink}
              buttonTitle={convertedType[item.type].button}
            />
          }}
        />
      </div>
    );

    if (!this.props.user || !this.props.user.uid) {
      content = (
        <div className="container">
          <AskForLogin
            page="Saved Events"
          />
        </div>
      )
    };

    return (
      <React.Fragment>
        <PageHeader
          className="header"
          title="Search Results"
          extra={
            <div className="search-form">
              <FilterPanel
                filter={this.filterBy}
                type={type}
                reverseRedirection={this.state.reverseRedirection ? this.state.reverseRedirection : null}
                title={type ? convertedType[type].titleSearch : "Search"}
                deviceType
              />
            </div>
          }
          extraMobile={
            <Button type="primary" shape="circle" icon="search" />
          }
          mobileTitleSearch={type ? convertedType[type].titleSearch : "Search"}
          mobileTypeSearch={type}
          reverseRedirection={this.state.reverseRedirection ? this.state.reverseRedirection : null}
        />
        <div className="search">
          {content}
        </div>
      </React.Fragment>
    );
  };
};



// WEBPACK FOOTER //
// ./src/pages/Search/index.js